import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_DOCENTETE_SCHEMA_LITERAL = {
    title: 'Schéma EnteteDocument',
    description: 'Document',
    version: 6,
    keyCompression: false,
    primaryKey : { key : 'DO_PIECE_PK', fields : ['USER_ID', 'DO_PIECE'], separator : '_' },
    type: 'object',
    properties: {
        DO_PIECE_PK: { type: 'string', maxLength: 60 },
        USER_ID: { type: 'string' },
        MD_SITEGID : { type : 'string' },
        MD_SITE : { type : 'string' },
        MD_DATE_CREATION : { type : 'string' },
        MD_CBMARQ : { type : 'number' },
        DO_TIERS : { type : 'string' },
        CT_INTITULE : { type : 'string' },
        CT_ENCOURS: { type: ['number', 'null'] },
        CT_TAUX01: { type: ['number', 'null'] },
        DO_REM_CONFLICT_MODE : { type: ['number', 'null'] },
        DO_REF : { type : 'string', default : '' },
        DO_DATE : { type : 'string' },
        DR_DATE : { type : 'string' },
        DO_PIECE : { type : 'string' },
        DO_PIECE_INTERNAL : { type : 'string' },
        DO_DATE_SEMAINE: { type: ['string', 'null'] },
        DO_DATE_MOIS: { type: ['string', 'null'] },
        DO_DATE_MOIS_UNIQUEMENT: { type: ['string', 'null'] },
        DO_DATE_TRIMESTRE: { type: ['string', 'null'] },
        DO_DATE_SEMESTRE: { type: ['string', 'null'] },
        DO_DATE_ANNEE: { type: ['string', 'null'] },
        DO_COORD01 : { type : 'string', default : '' },
        DO_COORD02 : { type : 'string', default : '' },
        DO_COORD03 : { type : 'string', default : '' },
        DO_COORD04 : { type : 'string', default : '' },
        CG_NUM: { type: ['string', 'null'] },
        ECHU_J: { type: ['number', 'null'] },
        CO_NO : { type : 'number' },
        CO_LIB : { type : ['string', 'null'] },
        CA_NUM: { type: ['string', 'null'] },
        CA_INTITULE: { type: ['string', 'null'] },
        DO_TYPE: { type: 'number' },
        DO_TYPELIB: { type: ['string', 'null'] },
        DO_PROVENANCELIB: { type: ['string', 'null'] },
        DE_NO: { type: 'number' },
        DE_INTITULE: { type: 'string' },
        DO_STATUT: { type: 'number', default : 0 },
        DO_STATUTLIB: { type: ['string', 'null'] },
        DO_SOUCHE: { type: 'number' },
        DO_SOUCHELIB: { type: ['string', 'null'] },
        N_CATCOMPTA: { type: 'number', default : 0 },
        CATCOMPTALIB: { type: ['string', 'null'] },
        DO_DEVISE : { type : 'number', default : 0 },
        DO_DEVISELIB : { type : 'string' },
        DO_DEVISE_FORMAT : { type : 'string' },
        DO_DEVISE_INV : { type : 'number', default : 0 },
        DO_COURS : { type : 'number', default : 0 },
        DO_TOTALHT: { type: 'number', default : 0 },
        DO_TOTALHTNET: { type: 'number', default : 0 },
        DO_TOTALTTC : { type : 'number', default : 0 },
        DO_NETAPAYER: { type: 'number', default : 0 },
        DO_SOLDETTC: { type: 'number', default : 0 },
        DO_MONTANTREGLE: { type: 'number', default : 0 },
        LC_CARTE_NUM  : { type : 'string' }, 
        N_ANALYTIQUE: { type: ['number', 'null'] },
        DO_TYPEFRAIS: { type: ['number', 'null'], default : 0 },
        DO_VALFRAIS: { type: ['number', 'null'], default : 0 },
        DO_TYPEFRANCO: { type: ['number', 'null'], default : 0 },
        DO_TYPELIGNEFRAIS: { type: ['number', 'null'], default : 0 },
        DO_TXESCOMPTE: { type: ['number', 'null'], default : 0 },
        DO_ESCOMPTE: { type: ['number', 'null'], default : 0 },
        DO_VALIDE: { type: 'number', default : 0 },

        DO_TAXE1: { type: 'number' },
        DO_CODETAXE1: { type: 'string' },
        DO_TYPETAUX1: { type: 'number' },
        DO_TYPETAXE1: { type: 'number' },
        DO_TAXE2: { type: 'number' },
        DO_CODETAXE2: { type: 'string' },
        DO_TYPETAUX2: { type: 'number' },
        DO_TYPETAXE2: { type: 'number' },
        DO_TAXE3: { type: 'number' },
        DO_CODETAXE3: { type: 'string' },
        DO_TYPETAUX3: { type: 'number' },
        DO_TYPETAXE3: { type: 'number' },
        
        DO_EXPEDIT: { type: ['number', 'null'], default : 0 },
        DO_EXPEDITLIB: { type: ['string', 'null'] },
        DO_EXPEDIT_ARREF: { type: ['string', 'null'] },
        DO_CONDITION: { type: ['number', 'null'], default : 0 },
        DO_CONDITIONLIB: { type: ['string', 'null'] },

        CL_EXTRAS  : { type : ['string', 'null'] }, 

        DE_INTITULE_ORIG: { type: ['string', 'null'] },
        DE_INTITULE_DEST: { type: ['string', 'null'] },
        DO_TYPEI: { type: ['number', 'null'] },
        DO_TYPEI_LIB: { type: ['string', 'null'] },
        DO_TYPEI_INTITULE: { type: ['string', 'null'] },
        DO_DATELIVR: { type: ['string', 'null'] },
        DO_CONTACT: { type: ['string', 'null'] },
        DO_LANGUE: { type: ['number', 'null'] },
        DO_LANGUE_LIB: { type: ['string', 'null'] },
        LI_NO: { type: ['number', 'null'] },
        LI_LIB: { type: ['string', 'null'] },
        CT_NUMPAYEUR: { type: ['string', 'null'] },
        CT_NUMCENTRALE: { type: ['string', 'null'] },
        DO_TARIF: { type: ['number', 'null'] },
        DO_TARIF_LIB: { type: ['string', 'null'] },

        ZSYNCUP_FLAG  : { type : 'number', default : 0 },
        ZSYNCUP_STATUS  : { type : 'string' },
        ZSYNCUP_ERROR_MESSAGE  : { type : 'string' },
        ZSYNCUP_DATETIME  : { type : 'string' },
        ZSYNCUP_FEEDID  : { type : 'string' },

        CT_CBCREATION: { type: ['string', 'null'] },
        CT_TELEPHONE: { type: ['string', 'null'] },
        CT_TELECOPIE: { type: ['string', 'null'] },
        CT_EMAIL: { type: ['string', 'null'] },
        CT_SITE: { type: ['string', 'null'] },
        CT_FACEBOOK: { type: ['string', 'null'] },
        CT_LINKEDIN: { type: ['string', 'null'] },
        CT_SIRET: { type: ['string', 'null'] },
        CT_IDENTIFIANT: { type: ['string', 'null'] },
        BT_INTITULE: { type: ['string', 'null'] },
        CT_ADRESSE: { type: ['string', 'null'] },
        CT_COMPLEMENT: { type: ['string', 'null'] },
        CT_CODEPOSTAL: { type: ['string', 'null'] },
        CT_CODEREGION: { type: ['string', 'null'] },
        CT_VILLE: { type: ['string', 'null'] },
        CT_PAYS: { type: ['string', 'null'] },

        CO_NOM: { type: ['string', 'null'] },
        CO_PRENOM: { type: ['string', 'null'] },
        CO_FONCTION: { type: ['string', 'null'] },
        CO_ADRESSE: { type: ['string', 'null'] },
        CO_COMPLEMENT: { type: ['string', 'null'] },
        CO_CODEPOSTAL: { type: ['string', 'null'] },
        CO_VILLE: { type: ['string', 'null'] },
        CO_PAYS: { type: ['string', 'null'] },
        CO_SERVICE: { type: ['string', 'null'] },
        CO_TELEPHONE: { type: ['string', 'null'] },
        CO_EMAIL: { type: ['string', 'null'] },
    },
    required: [ 'DO_PIECE', 'DO_PIECE_INTERNAL', 'DO_DATE', 'DO_TIERS', 'CT_INTITULE', 'DO_TOTALHT', 'DO_TOTALTTC', 'DO_NETAPAYER', 'DO_SOLDETTC', 'DO_MONTANTREGLE' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_DOCENTETE_SCHEMA_LITERAL);
export type RxCluDocEnteteDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_DOCENTETE_SCHEMA: RxJsonSchema<RxCluDocEnteteDocumentType> = CLU_DOCENTETE_SCHEMA_LITERAL;
